import { mapGetters, mapActions } from 'vuex'

import Configuration from '@/agilis/util/Configuration'
import UnStyledLink from '@/agilis/components/UnstyledLink/UnstyledLink.vue'

export default {
  name: 'Tabs',

  props: {
    tabs: {
      type: Array,
      default: () => ([])
    },
    initialTabsMenuIsOpen: {
      type: Boolean,
      default: true
    },
    forceTabsMenuIsCollapsible: {
      type: Boolean,
      default: null
    },
    forceAutomaticTabsMenuCollapse: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      tabsMenuIsOpen: true
    }
  },

  components: {
    UnStyledLink
  },

  beforeMount: function () {
    if (this.tabsMenuIsCollapsible) {
      const route = this.dumpRoute
      const userLastActivity = this.userActivities(route) || {}
      this.tabsMenuIsOpen = userLastActivity.tabsMenuIsOpen ?? this.initialTabsMenuIsOpen ?? true
    } else {
      this.tabsMenuIsOpen = true
    }
  },

  computed: {
    ...mapGetters({
      selectedContext: 'contextStore/selectedContext',
      applicationId: 'contextStore/applicationId',
      workspaceId: 'contextStore/workspaceId',
      trackerTypeId: 'contextStore/trackerTypeId',
      userActivities: 'userActivityStore/userActivities'
    }),

    tabsMenuIsCollapsible () {
      return this.forceTabsMenuIsCollapsible ?? Configuration.getApplication(this.applicationId).verticalTabsCollapse ?? false
    },

    automaticTabsMenuCollapse () {
      return this.forceAutomaticTabsMenuCollapse
    },

    dumpRoute () {
      return `/api/${this.applicationId}`
    },

    activeTab: {
      get: function () {
        return (this.trackerTypeId && !!this.tabIds.find(t => t === this.trackerTypeId))
          ? this.tabIds.indexOf(this.trackerTypeId)
          : 0
      },
      set: function () {
        // used to remove Vue warning
        // Computed property was assigned to but it has no setter
      }
    },

    tabIds () {
      if (this.tabs && this.tabs.length > 0) {
        return this.tabs.map(t => {
          if (typeof t === 'string') return t
          return t.id
        })
      }
      return []
    },

    rerenderKey () {
      return this.tabIds.join('__')
    },

    tabItemStyle () {
      let headersHeight = 64
      const tabBarIsVisible = Configuration.getApplicationTabs(this.applicationId, this.workspaceId).length > 1
      if (tabBarIsVisible) {
        headersHeight = headersHeight + 40
      }
      return `height: calc(100vh - ${headersHeight}px); overflow: auto; margin-left: 2px;`
    },

    collapseIcon () {
      return this.tabsMenuIsOpen === true ? ' mdi-flip-h' : ''
    }
  },

  watch: {
    tabsMenuIsOpen (nextValue) {
      const route = this.dumpRoute
      const delta = {
        tabsMenuIsOpen: nextValue
      }
      this.persistUserAction({ route, delta })
    }
  },

  methods: {
    ...mapActions({
      'notifyError': 'notificationStore/notifyError',
      'persistUserAction': 'userActivityStore/persistUserAction'
    }),

    handleTabClick (tabId) {
      if (this.tabsMenuIsCollapsible && this.automaticTabsMenuCollapse) {
        this.tabsMenuIsOpen = false
      }
      this.$router.agilis.viewTrackerTable(tabId)
    },

    tabHref (tabId) {
      return this.$router.agilis.urlTrackerTable(tabId)
    },

    collapseTabsMenu () {
      this.tabsMenuIsOpen = !this.tabsMenuIsOpen
    }
  }
}
